"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historicalReportNavigationTranslations = {
    "en": {
        selectDateRange: "Select date range",
        runReport: "RUN REPORT",
    },
    "de": {
        selectDateRange: "Zeitraum auswählen",
        runReport: "BERICHT AUSFÜHREN",
    },
    "nl": {
        selectDateRange: "Datumbereik selecteren",
        runReport: "RAPPORT DRAAIEN",
    },
    "it": {
        selectDateRange: "Seleziona il periodo",
        runReport: "AVVIA RAPPORTO",
    },
    "fr": {
        selectDateRange: "Sélectionner une plage de dates",
        runReport: "EXÉCUTER LE RAPPORT",
    },
    "es": {
        selectDateRange: "Seleccione un intervalo de fechas",
        runReport: "EJECUTAR INFORME",
    },
    "ja": {
        selectDateRange: "データ範囲を選択する",
        runReport: "報告書の実行",
    },
    "en-GB": {
        selectDateRange: "Select date range",
        runReport: "RUN REPORT",
    },
    "ru": {
        selectDateRange: "Выбрать промежуток времени",
        runReport: "ЗАПУСТИТЬ РЕПОРТ",
    },
};
